@if (session) {
  <div class="personne-infos">
    <div class="infos-part">
      <div class="libelle">{{session.libelle}}</div>
      <!--<div class="tel" *ngIf="hasVille">{{entreprise.ville}}</div>-->
    </div>
  </div>
}

